import React from 'react'
import { useDispatch } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import UpsellModal from '~/Common-Objects/UpsellModal'
import { alterFullpage, alterSiteDrawer } from '~/data/actions/siteActions'
import * as Styles from './index.module.scss'
import FloatingActionBar from './svgs/floatingActionBar'

const CustomBlocksEmptyState = ({ showUpsell = false, onUpgrade, isForm = false, isLandingPage = false }) => {
    const dispatch = useDispatch()
    const productLabel = isLandingPage ? 'landing pages' : isForm ? 'forms' : 'emails'

    const showUpsellModal = () => {
        const modal = (
            <UpsellModal
                feature={'customTemplateBlocks'}
                requiredTier={'Growth'}
                onUpgrade={() => {
                    dispatch(alterFullpage(null))
                    dispatch(alterSiteDrawer(false, true, 'right', null))
                    onUpgrade()
                }}
            />
        )
        dispatch(alterFullpage(modal))
    }

    return (
        <div className={Styles.root}>
            <FloatingActionBar />
            <div className={Styles.title}>Reuse content across your {productLabel}</div>
            <p className={Styles.description}>
                Save your favourite layouts such as headers or footers, and reuse them across templates in seconds.
                Upgrade to Growth to start saving content blocks.
            </p>
            {showUpsell && (
                <Button
                    iconLeft={<Icons icon='chevronsUp' />}
                    className='button-primary button-sml'
                    onClick={showUpsellModal}
                    data-ph='dragdrop-elementpicker-customblocks-upsell'
                >
                    Upgrade to Growth
                </Button>
            )}
        </div>
    )
}

export default CustomBlocksEmptyState
